export default __webpack_public_path__ + "static/media/Sun.e5a9d8ca.svg";